import React, { Component } from 'react'
import {Carousel, Button, Modal, Col, Popover, OverlayTrigger } from 'react-bootstrap'
import FormContact  from '../form'
import Spinner from '../../../../Spinner'
import Slider from 'react-slick'
import { translate } from 'react-translate'
import { ShareButtons, ShareCounts, generateShareIcon } from 'react-share'
import { DIST_URL } from '../../../../../constants/api'

@translate('Propiedad')
class SliderDetail extends Component {

  next(e) {
    e.preventDefault()
    e.stopPropagation()
    this.refs.slider2.slickNext()
  }
  previous(e) {
    e.preventDefault()
    e.stopPropagation()
    this.refs.slider2.slickPrev()
  }

  render () {

    const {
      showModal,
      modalType,
      onClickModal,
      onChangeInfoType,
      property,
      telephone,
      t
    } = this.props

    //Social Share
    let baseUrl = window.location.href
    let shareUrl = baseUrl + '/' + property.property_code

    const { FacebookShareButton, LinkedinShareButton, TwitterShareButton } = ShareButtons

    const FacebookIcon = generateShareIcon('facebook')
    const TwitterIcon = generateShareIcon('twitter')
    const LinkedinIcon = generateShareIcon('linkedin')
    const title = 'LJ Ramos'

    const popoverShare = (
      <Popover id='popover-share'>
        <FacebookShareButton
          url={shareUrl}
          title={title}>
          <FacebookIcon
            size={20}
            round={false} />
        </FacebookShareButton>
        <TwitterShareButton
          url={shareUrl}
          title={title}>
          <TwitterIcon
            size={20} />
        </TwitterShareButton>
        <LinkedinShareButton
          url={shareUrl}
          title={title}>
          <LinkedinIcon
            size={20} />
        </LinkedinShareButton>
      </Popover>
    )

    const settingsSlider = {
      className: 'property-slider-list',
      dots: false,
      lazyLoad: false,
      arrows: false,
      centerMode: true,
      centerPadding: '120px',
      speed: 300,
      autoplaySpeed: 5000,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 768, settings: {
          slidesToShow: 1,
          centerMode: false,
          centerPadding: '0',
         } },
        { breakpoint: 1024, settings: {
          slidesToShow: 1,
          centerMode: false,
          centerPadding: '0',
        } }
      ]
    }

    let proImages = []
    if (property.images && property.images.length) {
      proImages = property.images
    } else if (property.image) {
      proImages.push(property.image)
    } else {
      proImages.push('/assets/images/placeholder-hotels.png')
    }

    if (proImages.length > 1 ) {
      var botones = true
    } else {
      var botones = false
    }
    var next = <i className='fa fa-angle-right fa-3x'></i>
    var prev = <i className='fa fa-angle-left fa-3x'></i>
    var nextSmall = <i className='fa fa-angle-right'></i>
    var prevSmall = <i className='fa fa-angle-left'></i>
    var classes = ''
    let buttonMap = ''
    let buttonClip = ''
    let buttonImg360 = ''
    if (property) {
      classes = (property.operation_type.name === 'Alquiler') ? 'propiedad-tipo' + ' ' + 'rent' : 'propiedad-tipo' + ' ' + 'sale'
    }

    if(property && property.plans && property.plans.length){
      buttonMap = (
        <div className='btn-grp-slider'>
          <Button type='submit' className='icon-box hidden-xs' onClick={() =>onClickModal('plan')}>
            <img src={DIST_URL+'/assets/images/plan-red.png'}/>
          </Button>
          <Button type='submit' className='icon-box visible-xs' onClick={() =>onClickModal('plan')}>
            <img src={DIST_URL+'/assets/images/plan-red.png'}/>
            Ver Planos
          </Button>
        </div>
      )
    }
    else{
      buttonMap = (
        <div className='btn-grp-slider'>
          <Button type='submit' className='icon-box hidden-xs' disabled>
            <img src={DIST_URL+'/assets/images/plans-disabled.png'}/>
          </Button>
          <Button type='submit' className='icon-box visible-xs' disabled>
            <img src={DIST_URL+'/assets/images/plans-disabled.png'}/>
            Ver Planos
          </Button>
        </div>
      )
    }
    if(property && property.videos && property.videos.length){
      buttonClip = (
        <div style={{ zIndex: 100 }}>
          <Button type='submit' className='icon-box hidden-xs able' onClick={() =>onClickModal('clip')}>
            <img src={DIST_URL+'/assets/images/clip.png'}/>
          </Button>
          <Button type='submit' className='icon-box visible-xs able' onClick={() => {
            onClickModal('clip')
          }}>
            <img src={DIST_URL+'/assets/images/clip.png'}/>
            Ver Video
          </Button>
        </div>
      )
    }
    else{
      buttonClip = (
        <div className='btn-grp-slider'>
          <Button  disabled={true} type='submit' className='icon-box hidden-xs' disabled>
            <img src={DIST_URL+'/assets/images/videos-disabled.png'}/>
          </Button>
          <Button  disabled={true} type='submit' className='icon-box visible-xs' disabled>
            <img src={DIST_URL+'/assets/images/videos-disabled.png'}/>
            Ver Video
          </Button>
        </div>
      )
    }

    if(property && property.tour_360){
      buttonImg360 = (
        <div className='btn-grp-slider'>
          <Button type='submit' className='icon-box hidden-xs' onClick={() =>onClickModal('tour_360')}>
            <img src={DIST_URL+'/assets/images/button-360.png'}/>
          </Button>
          <Button type='submit' className='icon-box visible-xs' onClick={() =>onClickModal('tour_360')}>
            <img src={DIST_URL+'/assets/images/button-360.png'}/>
            Ver 360
          </Button>
        </div>
      )
    }
    else{
      buttonImg360 = (
        <div className='btn-grp-slider'>
          <Button type='submit' className='icon-box hidden-xs' disabled>
            <img src={DIST_URL+'/assets/images/button-360-disabled.png'}/>
          </Button>
          <Button type='submit' className='icon-box visible-xs' disabled>
            <img src={DIST_URL+'/assets/images/button-360-disabled.png'}/>
            Ver 360
          </Button>
        </div>
      )
    }

    let icons = this.props.icons
    var content = ''
    var modalContent = ''
    var topContent = ''

    if (icons) {
      topContent = (
        <div className='top-information visible-xs'>
          <div className={classes}>
            {property.operation_type.name}
          </div>
          <div className='overlay'></div>
          <div className='btn-view-map'>
            <Button onClick={() =>onChangeInfoType('map')}> Ver Mapa </Button>
          </div>
        </div>
      )
      content = (
        <div className='icons-slider'>
          <div className='overlay visible-xs'></div>
          <Button type='submit' className='icon-box hidden-xs' onClick={() =>onClickModal('photo')}>
            <img src={DIST_URL+'/assets/images/photo-camera-red.png'}/>
          </Button>
          <Button type='submit' className='icon-box visible-xs' onClick={() =>onClickModal('photo')}>
            <img src={DIST_URL+'/assets/images/photo-camera.png'}/>
            Ver Fotos
          </Button>
          {buttonClip}
          {buttonMap}
          {buttonImg360}
        </div>
      )
    }
    else{
      content = (
        <div className='description-slider'>

        </div>
      )
    }

    if ((property) && (proImages)) {
      if (modalType === 'photo'){
        modalContent = (
          <Carousel indicators={false} nextIcon={nextSmall} prevIcon={prevSmall}>
            {proImages.map((item, index) =>
              <Carousel.Item  key={`proImage-${index}`}>
                <img className='img-back' src={item} alt={ property.title } title={ property.title } />
                <Carousel.Caption>

                </Carousel.Caption>
              </Carousel.Item>
            )}
          </Carousel>
        )
      }
      else if (modalType === 'plan'){
        modalContent = (
          <Carousel indicators={false} nextIcon={nextSmall} prevIcon={prevSmall}>
            {property.plans.map((item, index) =>
              <Carousel.Item  key={`property-plans-${index}`}>
                <img className='img-back' src={item} alt={ property.title } title={ property.title } />
                <Carousel.Caption>
                </Carousel.Caption>
              </Carousel.Item>
            )}
          </Carousel>
        )
      }
      else if (modalType === 'tour_360'){
        modalContent = (
          <iframe src={property.tour_360.player_url}></iframe>
        )
      }
      else {
        const video = property.videos && property.videos.length ?
          property.videos : null
        modalContent = video ? (
          <div className='modal-video'>
            <Carousel indicators={false} nextIcon={nextSmall} prevIcon={prevSmall}>
              {
                property.videos.map((v, i) => (
                  <Carousel.Item  key={`property-video-${i}`}>
                    <iframe
                      className='embeded-video'
                      src={v.player_url}
                      frameBorder='0'
                      allowFullScreen
                      >
                    </iframe>
                  </Carousel.Item>
                ))
              }
            </Carousel>
          </div>
        ) : null
      }
      let operationName
        if (property.operation_type.name == 'Venta/Alquiler'){
          operationName = `${t('Venta')} / ${t('Alquiler')}`
        }
        else{
          operationName = t(property.operation_type.name)
        }
        let height = (property.height === '0') ? '' : property.height
        let dir = (property.address).toLowerCase()
      return (
        <div>
          <Col lg={9} md={8} sm={12} className='no-padding'>
            { topContent }
            {
              proImages && proImages.length ?
                <Slider className='property-slider-list' ref='slider2' {...settingsSlider}>
                  {proImages.map((item, index) => {
                      return (
                        <div key={index} className='img-slider'>
                          <img className='img-back' src={item} alt={ property.title } title={ property.title } />
                        </div>
                      )
                    }
                  )}
                </Slider>:
                null
            }
            <div className='slider-buttons'>
              <div className='left-buttons'>
                <a onClick={(e) => {this.previous(e)}}>
                  <i className='fa fa-angle-left fa-3x' aria-hidden='true'></i>
                </a>
              </div>
              <div className='right-buttons'>
                <a onClick={(e) => {this.next(e)}}>
                  <i className='fa fa-angle-right fa-3x' aria-hidden='true'></i>
                </a>
              </div>
            </div>
            <div className='slider-navigation'>
              { content }
            </div>
          </Col>
          <Col lg={3} md={4} className='hidden-xs'>
            <div className='form-right'>
              <FormContact property={property}/>
              <div className='contact-row'>
                <span className='contact-whatsapp'>
                  <i className='fa fa-whatsapp'></i>
                  <a onClick={(e) => e.stopPropagation()} target='_blank' href={`https://api.whatsapp.com/send?phone=54911${telephone.replace(/\D+/g, '')}&text=${t('Consulta_WhatsApp_Interesado')}: ${property.property_type.name}  ${t('Consulta_WhatsApp_En')} ${operationName}%0A${t('Consulta_WhatsApp_Ubicado')} ${dir}%0A${t('Consulta_WhatsApp_Codigo')}: ${property.property_code}`} rel='noreferrer'>
                    <p>Whatsapp</p>
                  </a>
                </span>
                <span className='contact-phone'>
                  <i className='fa fa-phone'></i>
                  <a href={`tel:+5411${telephone}`}><p>(5411) - {telephone}</p></a>
                </span>
              </div>
            </div>
          </Col>
          <Modal
            show={showModal}
            onHide={onClickModal}
            container={this}
            aria-labelledby='contained-modal-title'
            bsSize='large'
          >
            <Modal.Body>
              <div className='slider-box'>
                <div className='box-close visible-xs'>
                  <Button type='submit' onClick={onClickModal} className='btn-close'>
                    <i className='fa fa-times fa-lg'></i>
                  </Button>
                </div>
                <div className='social-btns'>
                  <OverlayTrigger trigger='click' rootClose placement='bottom' overlay={popoverShare}>
                    <Button className='btn-icons'>
                      <i className='fa fa-share-alt fa-lg'></i>
                    </Button>
                  </OverlayTrigger>
                </div>
                { modalContent }
              </div>
              <div className='box-close'>
                <Button type='submit' onClick={onClickModal} className='btn-close'>
                  <i className='fa fa-times fa-lg'></i>
                </Button>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      )
    }
    else{
      return (
        <Spinner />
      )
    }
  }
}

export default SliderDetail



// WEBPACK FOOTER //
// ./src/components/Sections/Propiedades/Detail/Slider/index.js